/* eslint-disable react/prop-types */
import React from "react";
import propTypes from "prop-types";
import MaterialTable from "material-table";
import { TextField, InputAdornment } from "@material-ui/core";
//import { Controller } from "react-hook-form";

// import useStyles from "./stylesTableDirecciones";

const headerStyle = {
  // color: "#FFEBD1",
  // backgroundColor: "#FFFFFA"
  fontSize: "17px",
  overflow: "visible"
};

const columns = [
  { title: "Nombre", field: "nombre", headerStyle },
  {
    title: "Contenido",
    field: "contenido",
    headerStyle
  },
  {
    title: "Largo",
    field: "largo",
    headerStyle,
    editComponent: ({ rowData, onChange }) => (
      <TextField
        type="number"
        value={rowData.largo}
        onChange={e => onChange(e.target.value)}
        placeholder="Largo"
        inputProps={{ min: 0 }}
        styles={{ zIndex: 999 }}
        InputProps={{
          endAdornment: <InputAdornment position="end">cm</InputAdornment>
        }}
      />
    )
  },
  {
    title: "Alto",
    field: "alto",
    headerStyle,
    editComponent: ({ rowData, onChange }) => (
      <TextField
        type="number"
        onChange={e => onChange(e.target.value)}
        value={rowData.alto}
        placeholder="Alto"
        inputProps={{ min: 0 }}
        styles={{ zIndex: 999 }}
        InputProps={{
          endAdornment: <InputAdornment position="end">cm</InputAdornment>
        }}
      />
    )
  },
  {
    title: "Ancho",
    field: "ancho",
    headerStyle,
    editComponent: ({ rowData, onChange }) => (
      <TextField
        type="number"
        onChange={e => onChange(e.target.value)}
        value={rowData.ancho}
        placeholder="Ancho"
        inputProps={{ min: 0 }}
        styles={{ zIndex: 999 }}
        InputProps={{
          endAdornment: <InputAdornment position="end">cm</InputAdornment>
        }}
      />
    )
  },
  {
    title: "Peso",
    field: "peso",
    headerStyle,
    // eslint-disable-next-line react/display-name
    editComponent: ({ rowData, onChange }) => (
      <TextField
        type="number"
        onChange={e => onChange(e.target.value)}
        // eslint-disable-next-line react/prop-types
        value={rowData.peso}
        placeholder="Peso"
        inputProps={{ min: 0 }}
        styles={{ zIndex: 999 }}
        InputProps={{
          endAdornment: <InputAdornment position="end">kg</InputAdornment>
        }}
      />
    )
  }
];

const TablePaquetes = ({
  data = [],
  onAdd = () => {},
  onUpdate = () => {},
  onDelete = () => {}
}) => {
  // const classes = useStyles();
  return ( 
    <MaterialTable
      style={{ width: "100%" }}
      title="Paquetes"
      columns={columns}
      data={data}
      options={{
        exportButton: true
      }}
      localization={{
        body: {
          emptyDataSourceMessage: "Sin datos para mostrar",
          addTooltip: "Agregar",
          deleteTooltip: "Borrar",
          editTooltip: "Editar",
          filterRow: {
            filterTooltip: "Filtrar"
          },
          editRow: {
            deleteText: "Seguro que quieres borrar este registro?",
            cancelTooltip: "Cancelar",
            saveTooltip: "Guardar"
          }
        },
        header: {
          actions: ""
        },
        pagination: {
          labelDisplayedRows: "{from}-{to} de {count}",
          labelRowsPerPage: "Registros por página",
          labelRowsSelect: "registros",
          firstAriaLabel: "Primera página",
          firstTooltip: "Primera página",
          previousAriaLabel: "Anterior",
          previousTooltip: "Anterior",
          nextAriaLabel: "Siguiente",
          nextTooltip: "Siguiente",
          lastAriaLabel: "Último",
          lastTooltip: "Último"
        },
        toolbar: {
          exportTitle: "Exportar",
          exportAriaLabel: "Exportar",
          exportName: "Exportar como CSV",
          searchTooltip: "Buscar",
          searchPlaceholder: "Buscar"
        }
      }}
      
      
      editable={{
        onRowAdd: newData =>
          new Promise(resolve => {
            setTimeout(() => {
              onAdd(newData);
              resolve();
            }, 1000);
          }),
        onRowUpdate: newData =>
          new Promise(resolve => {
            // console.log(newData);
            setTimeout(() => {
              onUpdate(newData);
              resolve();
            }, 1000);
          }),
        onRowDelete: oldData =>
          new Promise(resolve => {
            setTimeout(() => {
              onDelete(oldData);
              resolve();
            }, 1000);
          })
      }}
    />
  );
};

TablePaquetes.propTypes = {
  data: propTypes.array,
  onAdd: propTypes.func,
  onUpdate: propTypes.func,
  onDelete: propTypes.func
};

export default TablePaquetes;
